import { createContext } from "react";
import { StorageContextProps } from "./models/storage-dto";

export const StorageContext = createContext<StorageContextProps | undefined>(
  undefined
);
